<template>
  <form>
    <md-card style="margin:40px 0!important;">
      <div class="row" style="margin-top: -52px;">
        <div class="col-md-6">
          <img :src="sidebarBackgroundImage" alt="" style="width: 45px;">
          {{product.extra_name}} ({{$t($route.name)}})
        </div>
        <div class="end col-md-6">
          <button type="button" class="mybtn btn saved" @click="Savedokument()">
            {{ $t("Сақлаш ва беркитиш") }} <sup>crl+enter</sup>
          </button>
          <router-link class="mybtn btn" :to="{ path: '/malumot/product/index' }">{{ $t("Чиқиш") }}<sup>esc</sup>
          </router-link>
        </div>
      </div>
      <md-card-content style="background: white!important;border-radius: 10px;">
        <div class="md-layout">
          <div class="row">
            <div class="col-md-2">
              <label>Код</label>
            </div>
            <div class="col-md-1">
              <input class="defaultinput" ref="focused" v-model="product.number" type="text" />
            </div>
            <div class="col-md-7"></div>
            <div class="col-md-1">
              <label for="">Папка</label>
            </div>
            <div class="col-md-1">
              <input type="checkbox" v-model="product.is_folder" />
            </div>
            <div class="col-md-2">
              <label>{{ $t("Умумий номи") }}</label>
            </div>
            <div class="col-md-6">
              <input type="text" readonly v-model="product.extra_name" class="defaultinput">
            </div>
            <div class="col-md-2">
              <label>{{ $t("Пачка") }}</label>
            </div>
            <div class="col-md-2">
              <input class="defaultinput" ref="focused" v-model="product.pack_count" type="text" />
            </div>
            <div class="col-md-2">
              <label>{{ $t("Номи") }}</label>
            </div>
            <div class="col-md-6">
              <input class="defaultinput" ref="focused" @input="Extra()" v-model="product.name" type="text" />
            </div>
            <div class="col-md-4"></div>
            <div class="col-md-8">
              <div class="row">
                <div class="col-md-6">
                  <div class="row productmodule">
                    <div class="col-md-4">
                      <label>{{ $t("Eд.изм.") }}</label>
                    </div>
                    <div class="col-md-8">
                      <v-select :clearable="true" class="md-input" :options="unitlist" v-model="product.unit_id"
                        :reduce="name => name.id" label="name">
                        <template #search="{attributes, events}">
                          <input class="vs__search" v-bind="attributes" v-on="events" />
                          <button type="button" class="modallist" v-b-modal.modal-unitlist>
                            <b-icon icon="three-dots"></b-icon>
                          </button>
                        </template>
                        <template v-slot:no-options="{ search, searching }">
                          <template v-if="searching">
                            <em><b>{{ search }}</b></em>
                            {{ $t("бўйича маьлумот йўқ") }}
                            <button type="button" class="pluss" @click="unit.name = search" v-b-modal.modal-unit>
                              +
                            </button>
                            <b>insert</b>
                          </template>
                          <em style="opacity: 0.5;" v-else>{{
                            $t("Маьлумот йўқ")
                            }}</em>
                        </template>
                      </v-select>
                    </div>
                    <div class="col-md-4">
                      <label>{{ $t("Гурух") }}</label>
                    </div>
                    <div class="col-md-8">
                      <v-select :clearable="true" class="md-input" :options="folder" v-model="product.parent_id"
                        :reduce="extra_name => extra_name.id" label="extra_name">
                        <template v-slot:no-options="{ search, searching }">
                          <template v-if="searching">
                            <em><b>{{ search }}</b></em>
                            {{ $t("бўйича маьлумот йўқ") }}
                          </template>
                          <em style="opacity: 0.5;" v-else>{{
                            $t("Маьлумот йўқ")
                            }}</em>
                        </template>
                      </v-select>
                    </div>
                    <div class="col-md-4">
                      <label>{{ $t("Давлат") }}</label>
                    </div>
                    <div class="col-md-8">
                      <v-select :clearable="true" class="md-input" :options="countrylist" @input="Countrychange"
                        v-model="product.country_id" :reduce="name => name.id" label="name">
                        <template #search="{attributes, events}">
                          <input class="vs__search" v-bind="attributes" v-on="events" />
                          <button type="button" class="modallist" v-b-modal.modal-countrylist>
                            <b-icon icon="three-dots"></b-icon>
                          </button>
                        </template>
                        <template v-slot:no-options="{ search, searching }">
                          <template v-if="searching">
                            <em><b>{{ search }}</b></em>
                            {{ $t("бўйича маьлумот йўқ") }}
                            <button type="button" class="pluss" @click="country.name = search" v-b-modal.modal-country>
                              +
                            </button>
                            <b>insert</b>
                          </template>
                          <em style="opacity: 0.5;" v-else>{{
                            $t("Маьлумот йўқ")
                            }}</em>
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <div class="row productmodule">
                    <div class="col-md-4">
                      <label>{{ $t("Доп. Имя") }} 1</label>
                    </div>
                    <div class="col-md-8">
                      <v-select :clearable="true" class="md-input" :options="extraunitlist"
                        v-model="product.extra_unit_id1" :reduce="name => name.id" @input="Extranamechange"
                        label="name">
                        <template #search="{attributes, events}">
                          <input class="vs__search" v-bind="attributes" v-on="events" />
                          <button @click="unittype=1" type="button" class="modallist" v-b-modal.modal-extraunitlist>
                            <b-icon icon="three-dots"></b-icon>
                          </button>
                        </template>
                        <template v-slot:no-options="{ search, searching }">
                          <template v-if="searching">
                            <em><b>{{ search }}</b></em>
                            {{ $t("бўйича маьлумот йўқ") }}
                            <button type="button" class="pluss" @click="extraunit.name = search;unittype=1;"
                              v-b-modal.modal-extraunit>
                              +
                            </button>
                            <b>insert</b>
                          </template>
                          <em style="opacity: 0.5;" v-else>{{
                            $t("Маьлумот йўқ")
                            }}</em>
                        </template>
                      </v-select>
                    </div>
                    <div class="col-md-4">
                      <label>{{ $t("Доп. Имя") }} 2</label>
                    </div>
                    <div class="col-md-8">
                      <v-select :clearable="true" class="md-input" :options="extraunitlist"
                        v-model="product.extra_unit_id2" :reduce="name => name.id" @input="Extranamechange2"
                        label="name">
                        <template #search="{attributes, events}">
                          <input class="vs__search" v-bind="attributes" v-on="events" />
                          <button @click="unittype=2" type="button" class="modallist" v-b-modal.modal-extraunitlist>
                            <b-icon icon="three-dots"></b-icon>
                          </button>
                        </template>
                        <template v-slot:no-options="{ search, searching }">
                          <template v-if="searching">
                            <em><b>{{ search }}</b></em>
                            {{ $t("бўйича маьлумот йўқ") }}
                            <button type="button" class="pluss" @click="extraunit.name = search;unittype=2;"
                              v-b-modal.modal-extraunit>
                              +
                            </button>
                            <b>insert</b>
                          </template>
                          <em style="opacity: 0.5;" v-else>{{
                            $t("Маьлумот йўқ")
                            }}</em>
                        </template>
                      </v-select>
                    </div>
                    <div class="col-md-4">
                      <label for="">{{ $t("Доп. Имя") }} 3</label>
                    </div>
                    <div class="col-md-8">
                      <input type="text" class="defaultinput" v-model="product.quality" @input="Extra()" />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row productmodule">
                    <div class="col-md-4">
                      <label>Бренд</label>
                    </div>
                    <div class="col-md-8">
                      <v-select :clearable="true" class="md-input" :options="brandlist" @input="Brandchange"
                        v-model="product.brand_id" :reduce="name => name.id" label="name">
                        <template #search="{attributes, events}">
                          <input class="vs__search" v-bind="attributes" v-on="events" />
                          <button type="button" class="modallist" v-b-modal.modal-brandlist>
                            <b-icon icon="three-dots"></b-icon>
                          </button>
                        </template>
                        <template v-slot:no-options="{ search, searching }">
                          <template v-if="searching">
                            <em><b>{{ search }}</b></em>
                            {{ $t("бўйича маьлумот йўқ") }}
                            <button type="button" @click="brand.name = search" v-b-modal.modal-brand class="pluss">
                              +
                            </button>
                            <b>insert</b>
                          </template>
                          <em style="opacity: 0.5;" v-else>{{
                            $t("Маьлумот йўқ")
                            }}</em>
                        </template>
                      </v-select>
                    </div>
                    <div class="col-md-4">
                      <label>Модел</label>
                    </div>
                    <div class="col-md-8">
                      <v-select :clearable="true" multiple class="md-input" :options="modellist" @input="Modelchange"
                        v-model="product.model_ids" :reduce="name => name.id" label="name">
                        <template #selected-option="option">
                          {{ modelOptionName(option) }}
                        </template>
                        <template #search="{attributes, events}">
                          <input class="vs__search" v-bind="attributes" v-on="events" />
                          <button type="button" class="modallist" v-b-modal.modal-modellist>
                            <b-icon icon="three-dots"></b-icon>
                          </button>
                        </template>
                        <template v-slot:no-options="{ search, searching }">
                          <template v-if="searching">
                            <em><b>{{ search }}</b></em>
                            {{ $t("бўйича маьлумот йўқ") }}
                            <button type="button" @click="model.name = search" v-b-modal.modal-model class="pluss">
                              +
                            </button>
                            <b>insert</b>
                          </template>
                          <em style="opacity: 0.5;" v-else>{{
                            $t("Маьлумот йўқ")
                            }}</em>
                        </template>
                      </v-select>
                    </div>
                    <div class="col-md-4">
                      <label>{{ $t("Ранг") }}</label>
                    </div>
                    <div class="col-md-8">
                      <v-select :clearable="true" class="md-input" :options="colourlist" @input="Colourchange"
                        v-model="product.colour_id" :reduce="name => name.id" label="name">
                        <template #search="{attributes, events}">
                          <input class="vs__search" v-bind="attributes" v-on="events" />
                          <button type="button" href="javascript:void(0)" class="modallist" v-b-modal.modal-colourlist>
                            <b-icon icon="three-dots"></b-icon>
                          </button>
                        </template>
                        <template v-slot:no-options="{ search, searching }">
                          <template v-if="searching">
                            <em><b>{{ search }}</b></em>
                            {{ $t("бўйича маьлумот йўқ") }}
                            <button type="button" @click="colour.name = search" v-b-modal.modal-colour class="pluss">
                              +
                            </button>
                            <b>insert</b>
                          </template>
                          <em style="opacity: 0.5;" v-else>{{
                            $t("Маьлумот йўқ")
                            }}</em>
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <div class="table100percent" style="margin:-2px -2px 0px -9px!important">
                    <md-card>
                      <md-card-content>
                        <table class="table table-bordered">
                          <thead>
                            <th class="column2">№</th>
                            <th>Штрих код
                              <button type="button" style="font-size: 12px;padding: 3px 5px;"
                                class="btn btn-primary needt" @click="Createshtrix()">
                                {{ $t("Янги") }} штрих
                              </button>
                              <button type="button" style="font-size: 12px;padding: 3px 5px;"
                                class="btn btn-primary needt" @click="Addshtrix(update)">
                                +
                              </button>
                            </th>
                          </thead>
                          <tbody style="overflow: hidden;">
                            <div style="overflow-y: scroll;height: 92px!important;">
                              <tr v-for="(item, index) in product.shtrix_table" :key="index">
                                <td class="column2">{{ index + 1 }}</td>
                                <td>
                                  <input type="text" class="table-input" v-model="item.shtrix_kod"
                                    @change="Addshtrix('update')" />
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </md-card-content>
                    </md-card>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="productimg">
              <div style="display: flex;">
                <label for="">Фото</label>
                <input type="file" id="files" ref="files" v-on:change="handleFilesUpload()" />
                <button v-if="product.picture_name!=''" type="button" @click="product.picture_name=''">
                  <b-icon style="color:red;" icon="x-lg"></b-icon>
                </button>
              </div>
              <img v-if="files!=''" v-bind:src="product.picture_name" style="max-height:220px;width: auto;padding:5px;" />
              <img v-else-if="product.picture_name!=''" v-bind:src="axios.defaults.baseURL+'/api/v1/uploads/'+product.picture_name"
                style="max-height:220px;width: auto;" />
              </div>
            </div>
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-4">
                  <div class="row productmodule" style="background-color: rgb(233 219 219);">
                    <div class="col-md-4" v-if="pricelist.length>0">
                      <label for="">Оптом нарх</label>
                    </div>
                    <div class="col-md-8" v-if="pricelist.length>0">
                      <input type="number" v-model="pricelist[0].optom_price" @change="Updateprice()"
                        class="defaultinput" />
                    </div>
                    <div class="col-md-4" v-if="pricelist.length>0">
                      <label for="">Оптом нарх $</label>
                    </div>
                    <div class="col-md-8" v-if="pricelist.length>0">
                      <input type="number" v-model="pricelist[0].optom_dollar_price" @change="Updateprice()"
                        class="defaultinput" />
                    </div>
                    <div class="col-md-4" v-if="pricelist.length>0">
                      <label for="">Чакана нарх</label>
                    </div>
                    <div class="col-md-8" v-if="pricelist.length>0">
                      <input type="number" @change="Updateprice()" v-model="pricelist[0].chakana_price"
                        class="defaultinput" />
                    </div>
                    <div class="col-md-4" v-if="pricelist.length>0">
                      <label for="">Чакана нарх $</label>
                    </div>
                    <div class="col-md-8" v-if="pricelist.length>0">
                      <input type="number" @change="Updateprice()" v-model="pricelist[0].chakana_dollar_price"
                        class="defaultinput" />
                    </div>
                    <div class="col-md-4" v-if="pricelist.length>0">
                      <label for="">Валюта:</label>
                    </div>
                    <div class="col-md-8" v-if="pricelist.length>0">
                      <input type="text" :disabled="true" class="defaultinput"
                        :value="pricelist[0].price_type==1?'Cўм':'Доллар'">
                    </div>
                  </div> 
                </div>
                <div class="col-md-8" v-if="pricelist.length>0">
                  <div class="table100percent" style="margin:-6px -2px 0px -9px!important">
                    <md-card>
                      <md-card-content>
                  <table class="table table-bordered">
                    <thead>
                      <th>{{$t('Вақт')}}</th>
                      <th>{{$t('Қолдиқ')}}</th>
                      <th>{{$t('Кирим')}} {{$t('Нарх')}}</th>
                      <th>{{$t('Етказувчи')}} {{$t('Нарх')}}</th>
                      <th>{{$t('Улгуржи')}} {{$t('Нарх')}}</th>
                      <th>{{$t('Улгуржи')}} {{$t('Нарх')}}$</th>
                      <th>{{$t('Чакана')}} {{$t('Нарх')}}</th>
                      <th>{{$t('Чакана')}} {{$t('Нарх')}}$</th>
                    </thead>
                    <tbody style="overflow: hidden;">
                      <div style="overflow-y: scroll;height: 142px!important;">
                      <tr v-for="(item,index) in serialist">
                        <td>{{SetDatetime(item.datetime)}}</td>
                        <td class="kol">{{item.balance}}</td>
                        <td class="kol">{{item.prixod_price}}</td>
                        <td class="kol">{{item.delivery_price}}</td>
                        <td class="kol">{{item.optom_price}}</td>
                        <td class="kol">{{item.optom_dollar_price}}</td>
                        <td class="kol">{{item.chakana_price}}</td>
                        <td class="kol">{{item.chakana_dollar_price}}</td>
                      </tr>
                      </div>
                    </tbody>
                  </table>
                  </md-card-content>
                  </md-card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import $ from "jquery";
import { print } from "../../../components/mixins/print.js";
export default {
  name: "product-modal-form",
  data() {
    return {
      sidebarBackgroundImage: require("@/assets/img/logomini.png"),
      unittype:1,
      files: "",
      folder:[],
      filter: "",
      unitlist: [],
      extraunitlist: [],
      countrylist: [],
      productlist: [],
      pricelist:[],
      serialist:[],
      unit: { name: "" },
      extraunit: { name: "" },
      model: { name: "" },
      modellist: [],
      brand: { name: "" },
      brandlist: [],
      colour: { name: "" },
      colourlist: []
    };
  },
  props: ["product"],
    mixins: [print],
  // computed: {
  //   // folder: function() {
  //   //   var all = [];
  //   //   this.productlist.forEach(function(key, value) {
  //   //     if (key.is_folder == 1) {
  //   //       all.push(key);
  //   //     }
  //   //   });
  //   //   return all;
  //   // }
  // },
  created() {
    let self = this;
    self.Folderlist();
    self.$root.$refs.product = self;
    self.$root.$on("unitone", function(getdata) {
      self.unit = getdata;
    });
    self.$root.$on("unitall", function(getdata) {
      self.unitlist = getdata;
    });
    self.$root.$on("unitselected", function(getdata) {
      self.product.unit_id = getdata;
    });
    self.$root.$on("extraunitone", function(getdata) {
      self.extraunit = getdata;
    });
    self.$root.$on("extraunitall", function(getdata) {
      self.extraunitlist = getdata;
    });
    self.$root.$on("extraunitselected", function(getdata) {
      if(getdata>0){
        if(self.unittype==1){
        self.product.extra_unit_id1 = getdata;
        setTimeout(() => {
        self.Extranamechange(self.product.extra_unit_id1);
        }, 100);
      }else{
        self.product.extra_unit_id2 = getdata;
        setTimeout(() => {
        self.Extranamechange2(self.product.extra_unit_id2);
        }, 100);
      }
      }
    });
    self.$root.$on("modelone", function(getdata) {
      self.model = getdata;
    });
    self.$root.$on("modelall", function(getdata) {
      self.modellist = getdata;
    });
    self.$root.$on("modelselected", function(getdata) {
      if(getdata>0){
        self.product.model_id = getdata;
        setTimeout(() => {
          self.Modelchange(self.product.model_id);
        }, 100);
      }
    });

    self.$root.$on("brandone", function(getdata) {
      self.brand = getdata;
    });
    self.$root.$on("brandall", function(getdata) {
      self.brandlist = getdata;
    });
    self.$root.$on("brandselected", function(getdata) {
      if(getdata>0){
        self.product.brand_id = getdata;
        setTimeout(() => {
          self.Brandchange(self.product.brand_id);
        }, 100);
      }
    });

    self.$root.$on("colourone", function(getdata) {
      self.colour = getdata;
    });
    self.$root.$on("colourall", function(getdata) {
      self.colourlist = getdata;
    });
    self.$root.$on("colourselected", function(getdata) {
      if(getdata>0){
        self.product.colour_id = getdata;
        setTimeout(() => {
          self.Colourchange(self.product.colour_id);
        }, 100);
      }
    });
    self.$root.$on("countryone", function(getdata) {
      self.country = getdata;
    });
    self.$root.$on("countryall", function(getdata) {
      self.countrylist = getdata;
    });
    self.$root.$on("countryselected", function(getdata) {
      if(getdata>0){
        self.product.country_id = getdata;
        setTimeout(() => {
          self.Countrychange(self.product.country_id);
        }, 100);
      }
    });
  },
  mounted: function() {
    this.Focus();
    this.Extra();
    this.normalizeModelIds();
    if(this.$route.params.id!=undefined){
      this.Pricelist();
      this.Serialist();
    }
  },
  methods: {
    Pricelist(){
      let self=this;
      axios({
        method: 'post',
        url: '/api/v1/product/price-list',
        data: {'product_id':self.$route.params.id,sklad_id:parseInt(localStorage.getItem('sklad_id'))}
      }).then(function(response) {
       self.pricelist=response.data;
      });
    },
    Serialist(){
      let self=this;
      axios({
        method: 'post',
        url: '/api/v1/product/series-list',
        data: {'product_id':self.$route.params.id,sklad_id:parseInt(localStorage.getItem('sklad_id'))}
      }).then(function(response) {
       self.serialist=response.data;
      });
    },
    Updateprice(){
      let self=this;
      axios({
        method: 'post',
        url: '/api/v1/product/update-price/'+self.pricelist[0].id,
        data: { 'product_id': self.$route.params.id, sklad_id: parseInt(localStorage.getItem('sklad_id')), optom_price: self.pricelist[0].optom_price,optom_dollar_price: self.pricelist[0].optom_dollar_price, chakana_price: self.pricelist[0].chakana_price,chakana_dollar_price: self.pricelist[0].chakana_dollar_price }
      }).then(function(response) {
      });
    },
    Folderlist() {
      let self = this;
        axios.get("api/v1/product/folder-list").then(function(response) {
          self.folder = response.data;
        });
    },
    Focus() {
      this.$refs.focused.focus();
    },
    handleFilesUpload() {
      this.files = this.$refs.files.files;
      this.product.picture_name = URL.createObjectURL(
        this.$refs.files.files[0]
      );
    },
     Createshtrix() {
      if (this.product.shtrix_table.length == 0) {
        this.Addshtrix();
      }
      var endcount;
      let self=this;
      if(this.$route.params.id!=undefined){
        endcount=this.$route.params.id;
        var creating =
        25 * 100000000000 +
        endcount;
        if (this.product.shtrix_table[0].shtrix_kod == "") {
          this.product.shtrix_table[0].shtrix_kod = creating;
        }
      }else{
        axios.get("api/v1/product/auto-increment-id").then(function(response) {
          endcount=response.data.AUTO_INCREMENT;
          var creating =
        25 * 100000000000 +
        endcount;
          if (self.product.shtrix_table[0].shtrix_kod == "") {
            self.product.shtrix_table[0].shtrix_kod = creating;
          }
        });
      }
    },
    Addshtrix(type) {
      this.product.shtrix_table.push({ shtrix_kod: "" });
      setTimeout(() => {
        var self = $(':focus'),form = self.parents(".row:eq(0)"),focusable,next,prev;
        focusable = form.find(".form-control");
        next = focusable.eq(-1);
        if(next.length){
          next.focus();
        }
      }, 1000);
    },
    Savedokument() {
      let self = this;      
      if(self.rule.change==true){
      if (this.$route.path == "/malumot/product/create") {
        var methods = "post";
        var action = "api/v1/product";
      } else {
        var methods = "patch";
        var action = "api/v1/product/id/" + self.$route.params.id;
      }
      let formData = new FormData();
      let file = this.files[0];
      formData.append("picture_name", file);
      formData.append("extra_name", this.product.extra_name);
      formData.append("name", this.product.name);
      if(this.product.unit_id==null){
        this.product.unit_id=0;
      }
      if(this.product.extra_unit_id1==null){
        this.product.extra_unit_id1=0;
      }
      if(this.product.extra_unit_id2==null){
        this.product.extra_unit_id2=0;
      }
      if(this.product.colour_id==null){
        this.product.colour_id=0;
      }
      if(this.product.parent_id==null){
        this.product.parent_id=0;
      }
      if(this.product.country_id==null){
        this.product.country_id=0;
      }
      if(this.product.model_id==null){
        this.product.model_id=0;
      }
      this.normalizeModelIds();
      if(this.product.brand_id==null){
        this.product.brand_id=0;
      }
      formData.append("number", this.product.number);
      formData.append("unit_id", this.product.unit_id);
      formData.append("extra_unit_id1", this.product.extra_unit_id1);
      formData.append("extra_unit_id2", this.product.extra_unit_id2);
      formData.append("colour_id", this.product.colour_id);
      formData.append("parent_id", this.product.parent_id);
      formData.append("is_folder", this.product.is_folder);
      formData.append("country_id", this.product.country_id);
      formData.append("model_id", this.product.model_id);
      formData.append("model_ids", this.product.model_ids.join(','));
      formData.append("brand_id", this.product.brand_id);
      formData.append("quality", this.product.quality);
      formData.append("pack_count", this.product.pack_count);
      if(this.product.shtrix_table.length>0){
        for (let i = 0; i < this.product.shtrix_table.length; i++) {
        formData.append(
          `shtrix_table[${i}][shtrix_kod]`,
          this.product.shtrix_table[i].shtrix_kod
        );
        }
      }else{
        formData.append(
          `shtrix_table[0][shtrix_kod]`,
          ""
        );
      }
      axios({
        method: methods,
        url: action,
        data: formData
      }).then(function(response) {
        self.$store.state.saved = 1;
        self.$router.push({ name: "Товар" });
      });
    } else{
          self.$store.state.errors=self.$t('Sizdan bunday xuquq mavjud emas');
    }
    },
    Colourchange(val) {
      let self = this;
      if (val == null) {
        self.product.colour = null;
        self.Extra();
      } else {
        axios.get("api/v1/colour/id/" + val).then(function(response) {
          self.product.colour = response.data;
          self.Extra();
        });
      }
    },
   Extranamechange(val) {
      let self = this;
      if (val == null) {
        self.product.extra_unit1 = null;
        self.Extra();
      } else {
        axios.get("api/v1/extra-unit/id/" + val).then(function(response) {
          self.product.extra_unit1 = response.data;
          self.Extra();
        });
      }
    },
    Extranamechange2(val) {
      let self = this;
      if (val == null) {
        self.product.extra_unit2 = null;
        self.Extra();
      } else {
        axios.get("api/v1/extra-unit/id/" + val).then(function(response) {
          self.product.extra_unit2 = response.data;
          self.Extra();
        });
      }
    },
    Brandchange(val) {
      let self = this;
      if (val == null) {
        self.product.brand = null;
        self.Extra();
      } else {
        axios.get("api/v1/brand/id/" + val).then(function(response) {
          self.product.brand = response.data;
          self.Extra();
        });
      }
    },
    Countrychange(val) {
      let self = this;
      if (val == null) {
        self.product.country = null;
        self.Extra();
      } else {
        axios.get("api/v1/country/id/" + val).then(function(response) {
          self.product.country = response.data;
          self.Extra();
        });
      }
    },
    Modelchange(val) {
      let self = this;
      const modelIds = Array.isArray(val) ? val : (val ? [val] : []);
      self.product.model_ids = modelIds;
      self.product.model_id = modelIds[0] || 0;
      if (modelIds.length === 0) {
        self.product.model = null;
        self.Extra();
      } else {
        axios.get("api/v1/model/id/" + modelIds[0]).then(function(response) {
          self.product.model = response.data;
          self.Extra();
        });
      }
    },
    normalizeModelIds() {
      const ids = Array.isArray(this.product.model_ids)
        ? this.product.model_ids
        : String(this.product.model_ids || '').split(',').filter(Boolean);
      this.product.model_ids = ids.map(Number).filter(Boolean);
      if (this.product.model_ids.length === 0 && this.product.model_id) {
        this.product.model_ids = [Number(this.product.model_id)];
      }
      this.product.model_id = this.product.model_ids[0] || 0;
    },
    modelOptionName(option) {
      const values = Array.isArray(option)
        ? option
        : (option && typeof option === 'object'
          ? [option]
          : String(option || '').split(',').filter(Boolean));
      return values.map(value => {
        const namedModel = value && typeof value === 'object'
          ? this.modellist.find(item => item.name === value.name || item.name === value.label)
          : null;
        if (namedModel) return namedModel.name;
        const nestedValue = value && typeof value === 'object'
          ? (value.option || value.value || value.id || value.label || value.name)
          : value;
        const nestedValues = Array.isArray(nestedValue)
          ? nestedValue
          : String(nestedValue || '').split(',').filter(Boolean);
        return nestedValues.map(itemValue => {
          const id = itemValue && typeof itemValue === 'object'
            ? (itemValue.id || itemValue.value || itemValue.option)
            : itemValue;
          const model = this.modellist.find(item => Number(item.id) === Number(id));
          return model ? model.name : '';
        }).filter(Boolean).join(', ');
      }).join(', ');
    },
    Extra() {
      let self = this;
      self.product.extra_name = self.product.name;
      if (self.product.extra_unit1 != null) {
        self.product.extra_name =
          self.product.extra_name + " " + self.product.extra_unit1.name;
      }
      if (self.product.extra_unit2 != null) {
        self.product.extra_name =
          self.product.extra_name + " " + self.product.extra_unit2.name;
      }
      if (self.product.colour != null) {
        self.product.extra_name =
          self.product.extra_name + " " + self.product.colour.name;
      }
      if (self.product.brand != null) {
        self.product.extra_name =
          self.product.extra_name + " " + self.product.brand.name;
      }
      if (self.product.country != null) {
        self.product.extra_name =
          self.product.extra_name + " " + self.product.country.name;
      }
      if (self.product.model != null) {
        self.product.extra_name =
          self.product.extra_name + " " + self.product.model.name;
      }
      if (self.product.quality != "") {
        self.product.extra_name =
          self.product.extra_name + " " + self.product.quality;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .row>div{
    padding: 5px;
    border-bottom:1px outset;
  }

  ::v-deep .md-input .vs__selected-options {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
    min-width: 0;
    height: auto;
    overflow: visible !important;
  }

  ::v-deep .md-input .vs__selected {
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    position: relative !important;
    margin: 2px 0 !important;
    padding: 4px 8px;
    overflow: hidden;
    border: 1px solid #c4b5fd;
    border-radius: 6px;
    background: #ede9fe;
    color: #5b21b6;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.2;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  ::v-deep .md-input .vs__deselect {
    flex-shrink: 0;
    margin-left: 6px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #7c3aed;
    font-size: 15px;
    line-height: 1;
  }

  ::v-deep .md-input .vs__search {
    min-width: 70px;
  }
/* .md-dialog .md-dialog-container {
    max-width: 768px;
  } */
</style>
